import { Site, SubSite } from 'graphql-api/gql-api-interfaces';

export interface ISite
  // tslint:disable-next-line:max-union-size
  extends Pick<Site, 'brandId' | 'siteId' | 'logoUrl' | 'title'> {
  siteTitle?: string | null;
  subSiteTitle?: string | null;
  subSiteId?: string;
}

export function getSiteInfo(site: Site, subSite?: SubSite): ISite {
  return {
    brandId: site.brandId,
    siteId: site.siteId,
    subSiteId: subSite?.subSiteId,
    logoUrl: !!subSite?.subSiteId ? subSite.logoUrl : site.logoUrl,
    title: !!subSite?.title ? subSite.title : site.title,
    siteTitle: site.title,
    subSiteTitle: subSite?.title,
  };
}

export const isCurrAndPrevSitesEqual = (
  prevSites: Site[],
  currSites: Site[],
): boolean => {
  if (prevSites?.length !== currSites?.length) {
    return false;
  }

  const prevSitesMap = new Map(prevSites.map((v) => [v.siteId, v.subSites]));
  return !currSites.some((currSitesSite) => {
    if (!prevSitesMap.has(currSitesSite.siteId)) {
      return true;
    }

    const prevSitesSubSites = prevSitesMap.get(currSitesSite.siteId);
    // if one of site's subSites does not exist or empty then it
    // does not make sense to check them out at all
    if (
      (!!currSitesSite.subSites && !prevSitesSubSites) ||
      (!currSitesSite.subSites && !!prevSitesSubSites)
    ) {
      return true;
    }

    // if there are subSites - we check them using recursion
    // and mapping to meet data structure (it does not actually harm us
    // as in this case it does not matter)
    if (!!prevSitesSubSites && !!currSitesSite.subSites) {
      // tslint:disable:no-non-null-assertion
      return !isCurrAndPrevSitesEqual(
        prevSitesSubSites.map((v) => ({ siteId: v!.subSiteId })),
        currSitesSite.subSites.map((v) => ({ siteId: v!.subSiteId })),
      );
      // tslint:enable:no-non-null-assertion
    }

    return false;
  });
};
